import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, Flex, Heading} from 'rebass';
import {AdaptedDropdown, AdaptedInput, AdaptedSwitch} from "./FormField";
import {Field, Form} from 'react-final-form';

import {buttonMarginTop, PopupWrapper} from "./styles";

const required = value => (value ? undefined : 'Required')

const ACTOR_SELECT_OPTIONS = [
	{value: '', label: 'Select'},
	{value: 'Deans', label: 'Deans'},
	{value: 'Parents', label: 'Parents'},
	{value: 'Host', label: 'Host'}
];

const LeaveTypeForm = props => {

	const remainingOptions = (valueFirst, valueSecond) => {
		return ACTOR_SELECT_OPTIONS.filter(actor => {
			return actor.value !== valueFirst && actor.value !== valueSecond;
		  });
	}	

	const {onSubmit, toggleOverlay, initialValues} = props;

	let title = 'New Leave Type'
	if(initialValues.name){
		title = initialValues.name
	}
	return (
		<PopupWrapper>
			<Form
				onSubmit={onSubmit}
				initialValues={initialValues}
				render={({ handleSubmit, form, submitting, pristine, values }) => {
					return (
						<form id="exampleForm" onSubmit={handleSubmit}>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Heading>{title}</Heading>

								<Flex flexDirection={'row'}>
									<Heading as={'h5'} pr={2}>Activate</Heading>
									<Field
										name={'activated'}
										component={AdaptedSwitch}
										type={'checkbox'}
									/>
								</Flex>
							</Flex>
							<Button variant={'main'} m={1} mt={buttonMarginTop}
							        bg={!values.name ? 'meta' : 'green'}
							        disabled={!values.name}
							        type="submit"

							>
								Save
							</Button>
							<Button variant={'main'} m={1} mt={buttonMarginTop} bg={'gray'} onClick={(e) =>{
								e.preventDefault();
								form.reset()
								toggleOverlay()
							}}>Cancel</Button>

							<Heading as={'h4'} mt={3} mb={2}>Name</Heading>
							<Card boxShadow={'main'}>

								<Field
									name="name"
									component={AdaptedInput}
									type="text"
									placeholder="Name goes here..."
									validate={required}
								/>

							</Card>

							<Heading as={'h4'} mt={3} mb={2}>Actors</Heading>
							
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
								<Flex flexDirection={'row'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>1st</Heading>
									<Field
										name="first_actor"
										component={AdaptedDropdown}
										options={remainingOptions(values.second_actor, values.third_actor)}
										filterTitle={'Select'}
										showSelected={true}
										titleFontSize={4}
									/>

								</Flex>
								<Flex flexDirection={'row'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>2nd</Heading>
									<Field
										name="second_actor"
										component={AdaptedDropdown}
										options={remainingOptions(values.first_actor, values.third_actor)}
										filterTitle={'Select'}
										showSelected={true}
										titleFontSize={4}
									/>
								</Flex>
								<Flex flexDirection={'row'} mt={3}>
									<Heading as={'h3'} color={'gray'} mr={2}>3rd</Heading>
									<Field
										name="third_actor"
										component={AdaptedDropdown}
										options={remainingOptions(values.first_actor, values.second_actor)}
										filterTitle={'Select'}
										showSelected={true}
										titleFontSize={4}
									/>
								</Flex>
							</Flex>

							<Flex flexDirection={'row'} mt={3}>
								<Heading as={'h3'} mb={2} mr={2} >Admin View-Only?</Heading>
								<Field
									name={'is_admin_only'}
									component={AdaptedSwitch}
									type={'checkbox'} 
								/>
							</Flex>
						</form>
					)
				}}
			/>
		</PopupWrapper>
	);
};

LeaveTypeForm.propTypes = {
	onSubmit: PropTypes.func,
	toggleOverlay: PropTypes.func,
	initialValues: PropTypes.object
};

LeaveTypeForm.defaultProps = {
	onSubmit: (values) => console.log('New Leave Type values', values),
	toggleOverlay: () => console.log("Closed overlay"),
	initialValues: {activated: false, details: ''}
};


export default LeaveTypeForm;
